export default __webpack_public_path__ + "static/media/telegram.2c3a9d4f.gif";